interface IJoyride {
  incrementVisitedCount: () => void;
  getVisitedCount: () => number | null;
}

const ANOBIS_VISITED_COUNT = "ANOBIS_VISITED_COUNT";
const JOYRIDE_THRESHOLD = 4;

class JoyrideService implements IJoyride {
  public get show() {
    return this.getVisitedCount() < JOYRIDE_THRESHOLD;
  }

  public getVisitedCount() {
    const value = localStorage.getItem(ANOBIS_VISITED_COUNT);
    if (value === null) {
      localStorage.setItem(ANOBIS_VISITED_COUNT, "0");
      return 0;
    }
    return Number(value);
  }

  public incrementVisitedCount() {
    const value = this.getVisitedCount() + 1;
    if (value > JOYRIDE_THRESHOLD) {
      return;
    }
    localStorage.setItem(ANOBIS_VISITED_COUNT, `${value}`);
  }
}
export default new JoyrideService();
